import { isTourV2Item } from 'lib/checkout/checkoutUtils'
import { isOfferDomestic } from 'lib/offer/isDomestic'
import getTourV2CountryCodesVisited from 'lib/tours/getTourV2CountryCodesVisited'

type ServiceFeeDestination = 'DOMESTIC' | 'INTERNATIONAL'

export default function getServiceFeeDestination(
  item: App.Checkout.TourV2Item | App.Checkout.BedbankHotelItem | App.Checkout.LEHotelItem,
  offer: App.AnyOffer | undefined,
): ServiceFeeDestination {
  if (!offer) {
    return 'INTERNATIONAL'
  }

  if (isTourV2Item(item)) {
    const itinerary = (offer as App.Tours.TourV2Offer).variations[item.purchasableOption.fkVariationId]?.itinerary
    const countryCodesVisited = itinerary ? getTourV2CountryCodesVisited(itinerary) : []
    return countryCodesVisited.length > 0 && countryCodesVisited.every(countryCode => countryCode === 'AU')
      ? 'DOMESTIC'
      : 'INTERNATIONAL'
  }

  return isOfferDomestic(offer as App.Offer | App.BedbankOffer, 'AU')
    ? 'DOMESTIC'
    : 'INTERNATIONAL'
}
